var _Path, _Path2, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgPilatesAndYoga(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 33,
    height: 31,
    viewBox: "-5 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#pilates-and-yoga_svg__clip0_3566_9911)",
    fill: props.fill
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M4.766 11.45a2.499 2.499 0 00.814-3.443 2.508 2.508 0 00-3.448-.812 2.499 2.499 0 00-.815 3.443 2.508 2.508 0 003.45.812z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M23.533 28.772l-8.326-15.5a1.536 1.536 0 00-.224-.304L2.49.385A1.308 1.308 0 00.644.38a1.302 1.302 0 00-.006 1.844l7.17 7.225-2.09 2.241a1.307 1.307 0 00-.348.888v5.202c0 .714.578 1.297 1.293 1.303l2.73.031-1.02 2.546-3.588 7.144a1.302 1.302 0 001.17 1.887c.478 0 .938-.266 1.168-.72l3.52-7.033 3.463-3.712 3.358 3.762 3.768 7.015a1.3 1.3 0 001.766.533c.634-.341.87-1.13.535-1.763zM7.975 14.675l1.623 1.831-1.623-.018v-1.813z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "pilates-and-yoga_svg__clip0_3566_9911"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h33v30.69H0z"
  })))));
}

export default SvgPilatesAndYoga;